import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';

const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null; // Render nothing while loading to prevent race conditions
  }

  return user ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
